<script>
import axios from "axios";
import UserAPI from "../../utils/api/user";
import VueTableDynamic from "@scripts/vendor/vue-table-dynamic";

export default {
  name: 'MyAccount',
  data() {
    return {
      params: {
        data: [["Date", "Project ID", "Tool Name", "Site Name", ""]],
        header: "row",
        sort: [0, 1, 3],
        headerHeight: 50,
        rowHeight: 50,
        pagination: true,
        pageSize: 5,
        pageSizes: [5, 10, 20, 50],
        columnWidth: [{ column: 0, width: 100 }, { column: 1, width: 120 }, { column: 2, width: 150 }, { column: 4, width: 180 }]
      },
      searchTerm: "",
    };
  },
  components: { VueTableDynamic },
  props: {
    dataUrl: String,
  },
  mounted() {
    this.api = new UserAPI(window.APIDEF);
    this.accountAPI = window.accountAPI;

    this.loadUserProjects();
    this.addPaginationObserver();
    this.addSortButtonListeners();
    this.addOpenListener();
  },
  methods: {
    formatDate(value) {
      var date = new Date(value);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    },
    loadUserProjects() {
      axios.get(`${this.dataUrl}`, {}).then(response => {
        console.log(response);
        const parsedData = response.data.results.map(item => [
          item.date,
          item.id,
          item.toolName,
          item.siteName,
          `<a
            href="${item.urlName}?quoteId=${item.sfId}"
            data-quote="${item.id}"
            class="quote-open link-cta u-cursor-p"
            >View Saved Project</a>
            `,
        ]);

        this.params.data = [...this.params.data, ...parsedData];
      });
    },
    logout() {
      this.api.logout();
    },
    loadMore() {
      if (this.totalShowing >= this.totalItems) return;
      this.totalShowing =
        this.totalShowing + this.increment >= this.totalItems
          ? this.totalItems
          : this.totalShowing + this.increment;
    },
    viewAll() {
      this.totalShowing = this.totalItems;
    },
    addOpenListener() {
      // DJ NOTE: This code is part of what you would have to do without
      // rewriting this Vue component to listen for the click to open of a particular project
      // We currently handle this in the KbMaxEmbedController when attempting to open a project

      // this.$el.addEventListener("click", async function (event) {
      //   const target = event.target;
      //   if (target && target.tagName == "A") {

      //     event.preventDefault();
      //     event.stopPropagation();
          
      //     const quote = target.getAttribute('data-quote');
      //     const href = target.getAttribute("href");
      //     console.log("Quote clicked: ", quote);

      //     //call the server to see if its in the null or done state
      //     const response = await fetch(`/site-api/kbmax/quotestatus/${encodeURIComponent(quote)}`, {
      //       method: 'GET',
      //       headers: {
      //         'Content-Type': 'application/json'
      //       }
      //     });

      //     if(response.ok){
           
      //       console.log(await response.json());
      //       console.log("Would redirect to ", href);
      //     }

          
      //   }
      // });
    },
    addPaginationObserver() {
      const MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver;

      const obsConfig = {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true,
      };

      new MutationObserver(mutationList => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            const pageSizeSelect = document.querySelector(
              ".v-table-dynamic .pagination-size"
            );
            const sizeOptions = document.querySelector(
              ".v-table-dynamic .pagination-size .size-options"
            );
            const sizeItems = document.querySelectorAll(
              ".v-table-dynamic .pagination-size .size-item"
            );
            const pageSelectors = document.querySelectorAll(
              ".v-table-dynamic .pagination-page .page-item"
            );

            [...sizeItems].forEach((item, index) => {
              const text = item.innerText.replace("/", " per ");

              item.setAttribute("tabindex", "0");
              item.setAttribute("aria-label", `Select ${text}`);
              item.setAttribute("role", "button");

              item.addEventListener("keydown", e => {
                if (e.key === "Enter") {
                  e.stopPropagation();

                  item.click();

                  sizeOptions.style.display = "none";

                  pageSizeSelect.focus();
                }
              });
            });

            pageSizeSelect.setAttribute("tabindex", "0");
            pageSizeSelect.setAttribute("aria-label", "Select page size");
            pageSizeSelect.setAttribute("role", "button");
            pageSizeSelect.addEventListener("keydown", e => {
              if (e.key === "Enter") {
                e.stopPropagation();

                pageSizeSelect.click();

                sizeItems[0].focus();
              }
            });

            [...pageSelectors].forEach((item, index) => {
              if (!item.classList.contains("is-disabled")) {
                item.setAttribute("tabindex", "0");
                item.setAttribute("role", "button");
              }

              if (index === 0) {
                item.setAttribute("aria-label", "Go to previous page");
              } else if (index === pageSelectors.length - 1) {
                item.setAttribute("aria-label", "Go to next page");
              } else {
                const text = item.innerText;

                item.setAttribute("aria-label", `Go to page ${text}`);
              }

              item.addEventListener("keydown", e => {
                if (e.key === "Enter") {
                  e.stopPropagation();

                  item.click();
                }
              });
            });
          }
        }
      }).observe(document.querySelector(".v-table-dynamic"), obsConfig);
    },
    addSortButtonListeners() {
      const sortBtns = document.querySelectorAll(".sort-btns");
      const ascSortBtns = document.querySelectorAll(
        ".sort-btns.sort-ascending"
      );
      const descSortBtns = document.querySelectorAll(
        ".sort-btns.sort-descending"
      );

      [...sortBtns].forEach(btn => {
        btn.style.outline = "none";

        btn.setAttribute("tabindex", "0");
        btn.setAttribute("role", "button");

        btn.addEventListener("keydown", e => {
          if (e.key === "Enter") {
            btn.click();
          }
        });
      });

      [...ascSortBtns].forEach(btn => {
        btn.setAttribute("aria-label", "Sort in ascending order");

        btn.addEventListener("focus", () => {
          btn.style.borderBottomColor = "#94D600";
        });

        btn.addEventListener("blur", () => {
          btn.style.borderBottomColor = "rgb(192, 196, 204)";
        });

        btn.addEventListener("click", () => {
          setTimeout(() => {
            btn.style.borderBottomColor = "#198040";
          }, 50);
        });
      });

      [...descSortBtns].forEach(btn => {
        btn.setAttribute("aria-label", "Sort in descending order");

        btn.addEventListener("focus", () => {
          btn.style.borderTopColor = "#94D600";
        });

        btn.addEventListener("blur", () => {
          btn.style.borderTopColor = "rgb(192, 196, 204)";
        });

        btn.addEventListener("click", () => {
          setTimeout(() => {
            btn.style.borderTopColor = "#198040";
          }, 50);
        });
      });
    },
  },
  computed: {
    filteredItems() {
      if (!!this.projects) {
        return this.projects.slice(0, this.totalShowing).map(item => {
          return item;
        });
      } else {
        return [];
      }
    },
    totalItems() {
      return this.projects ? this.projects.length : 0;
    },
  },
  watch: {
    searchTerm(value) {
      this.$refs.table.search(value, [3]);
    },
  },
};
</script>
